import { render, staticRenderFns } from "./DeleteAccountPage.vue?vue&type=template&id=0e299e92&scoped=true"
import script from "./DeleteAccountPage.vue?vue&type=script&lang=ts"
export * from "./DeleteAccountPage.vue?vue&type=script&lang=ts"
import style0 from "./DeleteAccountPage.vue?vue&type=style&index=0&id=0e299e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e299e92",
  null
  
)

export default component.exports